import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getCommissionStreamId } from '../helpers';
export default function*() {
    const streamId = getCommissionStreamId();
    const isFetching = yield select(selectors.isFetching, streamId);
    if (isFetching) {
        return;
    }
    yield put(withOffset.actions.fetch(streamId));
}

//# sourceMappingURL=fetchMoreCommissions.js.map